// --- Base Models (Output from API) ---

export interface UserModel {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  password?: string; // Pouze pro Create
}

export interface PasswordUpdateModel {
  userId: string;
  newPassword: string;
}

export interface UserLiteModel {
  id: string;
  firstName: string;
  lastName: string;
}

export interface ClubModel {
  id: number;
  name: string;
  faNumber?: string;
  isInternal: boolean;
  logoUrl?: string;
}

export interface PlayerModel {
  id: number;
  firstName: string;
  lastName: string;
  dateOfBirth?: string | Date;
  facrId?: string;
  currentClubId?: number;
  currentClub?: ClubModel;
  position?: string;
  isActive: boolean;
  transfers: TransferModel[];
  attachments: AttachmentModel[];
  created: string | Date;
  updated: string | Date;
}

export interface AttachmentModel {
  id?: number;
  fileName: string;
  fileType: string;
  filePathOrUrl: string;
  storageType: number;
  externalId?: string;
  uploadedAt: string | Date;
}

export interface CommentModel {
  id?: number;
  content: string;
  createdAt: string | Date;
  authorUserId?: string;
  transferId?: number;

  user?: UserLiteModel;
}

export interface TransferModel {
  id: number;
  playerId: number;
  player?: PlayerModel;
  fromClubId: number;
  fromClub?: ClubModel;
  toClubId: number;
  toClub?: ClubModel;
  date: string | Date;
  type: TransferType;
  status: TransferStatus;
  loanEndDate?: string | Date;
  isLoanActive: boolean;
  feeType: FeeType;
  amount?: number;
  amountPerMatch?: number;
  currency: string;
  note?: string;
  attachments: AttachmentModel[];
  comments: CommentModel[];
  created: string | Date;
  updated: string | Date;
}

// --- Transfer Period ---

export interface TransferPeriod {
  id: string;
  label: string;
  startDate: string;
  endDate: string;
  isCurrent: boolean;
}

// --- DataListResponse (Generic response wrapper) ---

export interface DataListResponse<T> {
  data: T[];
  totalRecords: number;
  page: number;
  pageSize: number;
}

// --- Enums ---

export enum AttachmentOwnerType {
  Transfer = 1,
  Player = 2,
  Comment = 3
}

export enum TransferType {
  Permanent = 1,
  Loan = 2,
  CooperationAgreement = 3
}

export enum FeeType {
  Free = 1,
  Fixed = 2,
  PerMatch = 3
}

export enum TransferStatus {
  ToResolve = 1,
  PendingOtherSide = 2,
  PendingOurSignatures = 3,
  PendingFacrConfirmation = 4,
  Resolved = 5,
  Cancelled = 6
}
